import { jsx as e } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
/* empty css             */
const s = ({ inline: n = !1, size: p = "large" }) => /* @__PURE__ */ e("div", { className: `adyen-pe-spinner__wrapper ${n ? "adyen-pe-spinner__wrapper--inline" : ""}`, children: /* @__PURE__ */ e("div", { className: `adyen-pe-spinner adyen-pe-spinner--${p}` }) });
export {
  s as default
};
